// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay-chatbot {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.674);
  z-index: 1000;
  top: 0;
  left: 0;
}

.overlay-chatbot{
  /* display: flex; */
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  width: 100%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.674); */
  /* z-index: 1000;
  top: 0;
  left: 0;   */
}

.modal-content-chatbot {
  display: flex;
  margin-left: 5px;
  flex-direction: column;
  margin-left: 25px;
  margin-right: 10px;
}

.chatbot-chatbot-container {
  width: 70vw;
  margin-top: 26px;
  margin-left: 20px;
  /* height:90vh; */
}
.modal-chatbot-container{
  width: 45vw;
  margin-top: 10px;
  margin-left: 20px;
}
.modal-chatbot-container2 {
  width: 75vw;
  margin-top: 10px;
  /* margin-left: 20px; */
  /* height:90vh; */
}
.right-section-chat-chatbot {
  border-radius: 10px;
  height: 500px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(116, 123, 169, 1);
  background-color: rgba(255, 255, 255, 0.05);
}

.left-section-chat-chatbot {
  background-color: #1E203D;
  border: 1px solid #6B5CD1;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 85vh;
}

.title-chart-chatbot {
  margin-top: 5px;
  margin-left: 5px;
  font-size: 13px;
  font-family: Graphik;
  font-weight: 400;
  white-space: nowrap;
}

.chat-input-container-chart-chatbot {
  display: flex;
}

.text-chart-chatbot {
  margin-top: 5px;
  color: white;
  /* background-color: rgba(37, 40, 67, 1); */
  font-size: 14px;
  font-weight: 350;
  margin-right: 5px;
  font-family: Graphik;
  padding-left: 7px;
  height: 80px;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #6B5CD1;
  background-color: #1A1C35;
  text-align: left;
}

.chat-input-chart-chatbot ::placeholder {
  color: white;
  font-family: Graphik;
  font-size: 14px;
  font-weight: 350;
}

.textarea:focus {
  outline: none;
  /* border-color: #747BA9; 
  box-shadow: 0 0 5px #747BA9  */
}

.chat-input-chart-chatbot {
  margin-left: 3%;
  margin-right: 10px;
  /* margin-top: 10px; */
  padding: 2px;
  width: 90%;
  font-family: 'Graphik', sans-serif;
  color: white;
  font-size: 14px;
  height: 15%;
}

.loader-chatbot {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.loader-f-chatbot {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 187px;
  padding-top: 80px;
}

.dot-loader {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}

.red-loader {
  background-color: rgba(107, 92, 209, 1);
  animation-delay: -0.32s;
}

.green-loader {
  background-color: rgba(107, 92, 209, 1);
  animation-delay: -0.16s;
}

.blue-loader {
  background-color: rgba(107, 92, 209, 1);
}

.loading-text-chatbot {
  background-color: #3498db;
  animation-delay: -0.48s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-10px);
  }
}

.img1-chart-chatbot {
  text-align: right;
}

.top-part-chart-chatbot {
  height: 40px;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: row;
  background-color: rgb(54, 54, 89);
  padding: 5px;
  color: white;
  font-size: 13px;
  font-weight: 500;
}

.middile-part-chart-chatbot {
  height: auto;
  color: white;
  font-size: 10px;
}

.user-message-container-chatbot {
  display: flex;
  justify-content: flex-start;
  /* Align to the left for user messages */
  margin: 5px 0;
}

.bot-message-container-chatbot {
  display: flex;
  justify-content: flex-end;
  /* Align to the right for bot messages */
  margin: 5px 0;
}

.message-text-chart-chatbot {
  padding: 10px 10px 10px 10px;
  font-size: 12px;
  color: white;
  border-radius: 5px;
  max-width: 1000px;
  width: fit-content;
  margin-left: 30px;
}

.chat-messages-c-chatbot {
  height: 100%;
  color: white;
  font-size: 10px;
  overflow-y: scroll;
}

.section::-webkit-scrollbar-thumb {
  border: 5px solid transparent;
  border-radius: 100px;
  background-color: #8070d4;
  background-clip: content-box;
}

.chat-message-chart-chatbot {
  display: flex;
  border-radius: 5px;
  flex-direction: row;
}

.chat-message-chart-chatbot.user-c-chatbot {
  text-align: left;
}

.user-c-chatbot {
  /* align-items: end; */
  min-width: 50px;
  margin-top: 10px;
  margin-bottom: 10px;
  /* margin-right:10px; */
  /* margin-left: 100px; */
  text-align: left;
  position: relative;
  max-width: 500px;
  /* padding: 10px; */
  width: fit-content;
  float: left;
}

.user-c-chatbot-sop {
  /* align-items: end; */
  min-width: 60px;
  margin-top: 10px;
  margin-bottom: 10px;
  /* margin-right:10px; */
  /* margin-left: 100px; */
  text-align: left;
  position: relative;
  max-width: 500px;
  /* padding: 10px; */
  width: fit-content;
  float: left;
}

.bot-c-chatbot {
  min-width: 50px;
  margin-top: 10px;
  position: relative;
  max-width: 640px;
  margin-bottom: 10px;
  /* min-height: 60px; */
  /* max-height: 100%; */
  /* height: fit-content; */
  /* display: block; */
  /* overflow: auto; */
  padding: 10px;
  color: white;
  text-align: left;
  /* margin-right: 30px; */
  width: fit-content;
  float: left;
}

.bot-c-chatbot-sop {
  /* max-width: 80px; */
  margin-top: 10px;
  position: relative;
  /* max-width: 640px; */
  margin-bottom: 10px;
  /* min-height: 60px; */
  /* max-height: 100%; */
  /* height: fit-content; */
  /* display: block; */
  /* overflow: auto; */
  padding: 10px;
  padding-right: 50px;
  color: white;
  text-align: left;
  /* margin-right: 30px; */
  max-width: fit-content;
  float: left;
}
.bg-user-chatbot {
  background-color: rgba(116, 123, 169, 1);
  border-radius: 0px 10px 10px 10px;
  border-style: icon solid;
  min-width: 50px;
  margin-left: 40px;
}

.bg-bot-chatbot {
  background-color: rgba(45, 50, 90, 1);
  border-radius: 0px 10px 10px 10px;
  /* min-width: 50px; */
  /* max-width: 1100px; */
  /* height: auto; */
}
.load-chatbot{
  background-color: rgba(45, 50, 90, 1);
  border-radius: 0px 10px 10px 10px;
  padding: 10px 10px 10px 10px;
  border-radius: 5px;
  /* border: none; */
  width: fit-content;
  margin-left: 33px;
  margin-top: -30px;
}
.icon-chat-user-chatbot {
  width: 25px;
  position: absolute;
  margin-left: 10px;
  /* margin-right: 10px; */
  /* bottom: -15px; */
  /* left: -5px; */
}

.icon-chat-bot-chatbot {
  width: 25px;
  position: absolute;
  /* margin-right: 50px; */
  /* bottom: -15px; */
  /* right: -5px; */
}

.key-table-cb-chatbot {
  color: white;
  padding-top: 15px;
  padding-bottom: 5px;
  font-size: 13px;
  font-family: Graphik;
  font-weight: 400;
  margin-top: 27px;
  margin-left: 6px;
  line-height: 40px;
  margin-bottom: 10px;
}

.topside-chatbot {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.chat-table-chatbot {
  width: 20px;
}

.detected-ct-chatbot {
  background-image: linear-gradient(to right, rgba(72, 48, 239, 1), rgba(128, 69, 237, 1));
  height: 140px;
  width: 200px;
  margin-left: 15px;
  border-radius: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.heading-dt-chatbot {
  color: white;
  font-size: 14px;
  height: 30px;
  font-family: Graphik;
  font-weight: 500;
  text-align: center;
  width: 150px;
  margin-left: 25px;
}

.chatbot-img-chatbot {
  height: 90px;
  width: 180px;
  margin-left: 10px;
  margin-top: 10px;
  border-radius: 5px;
}

.detected-ct-below-chatbot {
  background-color: rgba(121, 93, 239, 1);
  height: 50px;
  width: 200px;
  color: white;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 500;
  margin-top: 14px;
  text-align: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 5px;
}

.insights-head-chatbot {
  color: white;
  font-size: 15px;
  font-family: Graphik;
  font-weight: 420;
  text-align: left;
  margin-top: 20px;
  margin-left: 10px;
}

.insight-button-chatbot {
  width: 400px;
  display: flex;
  margin-left: 10px;
  margin-top: 10px;
  flex-direction: column;
}

.insight-left-button-chatbot:hover {
  background-color: rgba(116, 123, 169, 1);
  transition: 0.7s;
}

.insight-left-button-l-chatbot:hover {
  background-color: rgba(116, 123, 169, 1);
  transition: 0.7s;
}

.insight-left-button-chatbot {
  height: 30px;
  min-width: 170px;
  max-width: 210px;
  border-radius: 18px;
  border-style: solid;
  border-color: rgba(116, 123, 169, 1);
  border-width: 1px;
  color: white;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
  background-color:
    rgba(37, 40, 67, 1);
  text-align: center;
  margin-bottom: 10px;
}

.insight-left-button-l-chatbot {
  height: 30px;
  width: 330px;
  border-radius: 18px;
  border-style: solid;
  border-color: rgba(116, 123, 169, 1);
  border-width: 1px;
  color: white;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
  background-color:
    rgba(37, 40, 67, 1);
  text-align: center;
  margin-bottom: 10px;
}

.send-icon-chatbot {
  width: 50px;
  height: 90px;
  display: flex;
  flex-direction: column;
  /* margin-top: 10px; */
  /* padding-top: 35px; */
}


.mic-chart-chatbot {
  padding: 2px;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  border: 1px solid rgba(116, 123, 169, 1);
  background-color: rgba(37, 40, 67, 1);
  margin-bottom: 10px;
}

.send-chart-chatbot {
  padding: 2px;
  width: 30px;
  height: 30px;
  margin-top: 30px;
  border-radius: 3px;
  border: 1px solid #747BA9;
  background-color: #1A1C35;
}

.bottom-part-chart-chatbot {
  margin-top: 10px;
  display: flex;
  width: 100%;
  background-color: rgb(54, 54, 89);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1px solid #6B5CD1;
}

.midside-chatbot {
  margin-top: 20px;
  border-top: 1px solid rgba(14, 190, 147, 1);
}

.message-footer-chatbot {
  display: flex;
  /* background-color: rgba(116, 123, 169, 1); */
  border: 1px solid rgba(116, 123, 169, 1);
  height: 34px;
  justify-content: space-between;
  padding: 5px 10px 5px 10px;
  margin: -10px;
  border-radius: 0px 0px 10px 10px;
  margin-top: 10px;
}

.msg-icon-chatbot {
  width: 17px;
  float: right;
  margin-right: 10px;
  padding-top: 2px;
}

.msg-icon-copy-chatbot {
  width: 12px;
  float: right;
  margin-right: 10px;
  padding-top: 2px;
}

.msg-icon-share-chatbot {
  width: 15px;
  float: right;
  margin-right: 10px;
  padding-top: 2px;
}

.border-score-chatbot {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid white;
  height: 20px;
}

.topside-table-chatbot {
  width: 187px;
  height: 180px;
}

.cal-data-chatbot {
  color: white;
  padding: 2px;
  margin-top: 6px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
}

.cal-one-chatbot {
  padding-right: 50px;
  /* justify-content: space-between; */
}

.cal-row-chatbot {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-family: Graphik;
  padding-top: 10px;
}

.container-cal-data-chatbot {
  background-color: #25304C;
  width: 100px;
  height: 30px;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  text-align: left;
  padding: 5px;
  color: white
}

.processebutton-calculate-chatbot {
  border-radius: 8px;
  margin-right: 40px;
  background-color: rgba(107, 92, 209, 1);
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 15px;
  width: 140px;
  height: 30px;
  /* border-style: solid; */
  border: 0px solid rgba(107, 92, 209, 1);
  float: right;
  margin-top: 30px;
  margin-bottom: 10px;
}

.add-data-chatbot {
  overflow-y: scroll;
  padding-top: 10px;
  height: 90%;
}

.table-chatbot {
  border-collapse: collapse;
  width: 100%;
}

.table-chatbot th {
  border: 1px solid rgba(87, 95, 142, 1);
  padding: 8px;
  text-align: center;
  background-color: rgba(60, 64, 105, 1);
}

.table-chatbot td {
  border: 1px solid rgba(87, 95, 142, 1);
  padding: 8px;
  text-align: left;
}

/* .icon-chatbot-g {
  width: "25px";
} */`, "",{"version":3,"sources":["webpack://./src/Generic_Chatbot.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,MAAM;EACN,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C;;cAEY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;gCAC8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wFAAwF;EACxF,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB;uBACqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB;uBACqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,wCAAwC;EACxC,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;GAEG","sourcesContent":[".modal-overlay-chatbot {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.674);\n  z-index: 1000;\n  top: 0;\n  left: 0;\n}\n\n.overlay-chatbot{\n  /* display: flex; */\n  justify-content: center;\n  align-items: center;\n  /* position: fixed; */\n  width: 100%;\n  height: 100%;\n  /* background-color: rgba(0, 0, 0, 0.674); */\n  /* z-index: 1000;\n  top: 0;\n  left: 0;   */\n}\n\n.modal-content-chatbot {\n  display: flex;\n  margin-left: 5px;\n  flex-direction: column;\n  margin-left: 25px;\n  margin-right: 10px;\n}\n\n.chatbot-chatbot-container {\n  width: 70vw;\n  margin-top: 26px;\n  margin-left: 20px;\n  /* height:90vh; */\n}\n.modal-chatbot-container{\n  width: 45vw;\n  margin-top: 10px;\n  margin-left: 20px;\n}\n.modal-chatbot-container2 {\n  width: 75vw;\n  margin-top: 10px;\n  /* margin-left: 20px; */\n  /* height:90vh; */\n}\n.right-section-chat-chatbot {\n  border-radius: 10px;\n  height: 500px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgba(116, 123, 169, 1);\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.left-section-chat-chatbot {\n  background-color: #1E203D;\n  border: 1px solid #6B5CD1;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  height: 85vh;\n}\n\n.title-chart-chatbot {\n  margin-top: 5px;\n  margin-left: 5px;\n  font-size: 13px;\n  font-family: Graphik;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.chat-input-container-chart-chatbot {\n  display: flex;\n}\n\n.text-chart-chatbot {\n  margin-top: 5px;\n  color: white;\n  /* background-color: rgba(37, 40, 67, 1); */\n  font-size: 14px;\n  font-weight: 350;\n  margin-right: 5px;\n  font-family: Graphik;\n  padding-left: 7px;\n  height: 80px;\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid #6B5CD1;\n  background-color: #1A1C35;\n  text-align: left;\n}\n\n.chat-input-chart-chatbot ::placeholder {\n  color: white;\n  font-family: Graphik;\n  font-size: 14px;\n  font-weight: 350;\n}\n\n.textarea:focus {\n  outline: none;\n  /* border-color: #747BA9; \n  box-shadow: 0 0 5px #747BA9  */\n}\n\n.chat-input-chart-chatbot {\n  margin-left: 3%;\n  margin-right: 10px;\n  /* margin-top: 10px; */\n  padding: 2px;\n  width: 90%;\n  font-family: 'Graphik', sans-serif;\n  color: white;\n  font-size: 14px;\n  height: 15%;\n}\n\n.loader-chatbot {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.loader-f-chatbot {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 187px;\n  padding-top: 80px;\n}\n\n.dot-loader {\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.red-loader {\n  background-color: rgba(107, 92, 209, 1);\n  animation-delay: -0.32s;\n}\n\n.green-loader {\n  background-color: rgba(107, 92, 209, 1);\n  animation-delay: -0.16s;\n}\n\n.blue-loader {\n  background-color: rgba(107, 92, 209, 1);\n}\n\n.loading-text-chatbot {\n  background-color: #3498db;\n  animation-delay: -0.48s;\n}\n\n@keyframes bounce {\n\n  0%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-10px);\n  }\n}\n\n.img1-chart-chatbot {\n  text-align: right;\n}\n\n.top-part-chart-chatbot {\n  height: 40px;\n  width: 100%;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  background-color: rgb(54, 54, 89);\n  padding: 5px;\n  color: white;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.middile-part-chart-chatbot {\n  height: auto;\n  color: white;\n  font-size: 10px;\n}\n\n.user-message-container-chatbot {\n  display: flex;\n  justify-content: flex-start;\n  /* Align to the left for user messages */\n  margin: 5px 0;\n}\n\n.bot-message-container-chatbot {\n  display: flex;\n  justify-content: flex-end;\n  /* Align to the right for bot messages */\n  margin: 5px 0;\n}\n\n.message-text-chart-chatbot {\n  padding: 10px 10px 10px 10px;\n  font-size: 12px;\n  color: white;\n  border-radius: 5px;\n  max-width: 1000px;\n  width: fit-content;\n  margin-left: 30px;\n}\n\n.chat-messages-c-chatbot {\n  height: 100%;\n  color: white;\n  font-size: 10px;\n  overflow-y: scroll;\n}\n\n.section::-webkit-scrollbar-thumb {\n  border: 5px solid transparent;\n  border-radius: 100px;\n  background-color: #8070d4;\n  background-clip: content-box;\n}\n\n.chat-message-chart-chatbot {\n  display: flex;\n  border-radius: 5px;\n  flex-direction: row;\n}\n\n.chat-message-chart-chatbot.user-c-chatbot {\n  text-align: left;\n}\n\n.user-c-chatbot {\n  /* align-items: end; */\n  min-width: 50px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  /* margin-right:10px; */\n  /* margin-left: 100px; */\n  text-align: left;\n  position: relative;\n  max-width: 500px;\n  /* padding: 10px; */\n  width: fit-content;\n  float: left;\n}\n\n.user-c-chatbot-sop {\n  /* align-items: end; */\n  min-width: 60px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  /* margin-right:10px; */\n  /* margin-left: 100px; */\n  text-align: left;\n  position: relative;\n  max-width: 500px;\n  /* padding: 10px; */\n  width: fit-content;\n  float: left;\n}\n\n.bot-c-chatbot {\n  min-width: 50px;\n  margin-top: 10px;\n  position: relative;\n  max-width: 640px;\n  margin-bottom: 10px;\n  /* min-height: 60px; */\n  /* max-height: 100%; */\n  /* height: fit-content; */\n  /* display: block; */\n  /* overflow: auto; */\n  padding: 10px;\n  color: white;\n  text-align: left;\n  /* margin-right: 30px; */\n  width: fit-content;\n  float: left;\n}\n\n.bot-c-chatbot-sop {\n  /* max-width: 80px; */\n  margin-top: 10px;\n  position: relative;\n  /* max-width: 640px; */\n  margin-bottom: 10px;\n  /* min-height: 60px; */\n  /* max-height: 100%; */\n  /* height: fit-content; */\n  /* display: block; */\n  /* overflow: auto; */\n  padding: 10px;\n  padding-right: 50px;\n  color: white;\n  text-align: left;\n  /* margin-right: 30px; */\n  max-width: fit-content;\n  float: left;\n}\n.bg-user-chatbot {\n  background-color: rgba(116, 123, 169, 1);\n  border-radius: 0px 10px 10px 10px;\n  border-style: icon solid;\n  min-width: 50px;\n  margin-left: 40px;\n}\n\n.bg-bot-chatbot {\n  background-color: rgba(45, 50, 90, 1);\n  border-radius: 0px 10px 10px 10px;\n  /* min-width: 50px; */\n  /* max-width: 1100px; */\n  /* height: auto; */\n}\n.load-chatbot{\n  background-color: rgba(45, 50, 90, 1);\n  border-radius: 0px 10px 10px 10px;\n  padding: 10px 10px 10px 10px;\n  border-radius: 5px;\n  /* border: none; */\n  width: fit-content;\n  margin-left: 33px;\n  margin-top: -30px;\n}\n.icon-chat-user-chatbot {\n  width: 25px;\n  position: absolute;\n  margin-left: 10px;\n  /* margin-right: 10px; */\n  /* bottom: -15px; */\n  /* left: -5px; */\n}\n\n.icon-chat-bot-chatbot {\n  width: 25px;\n  position: absolute;\n  /* margin-right: 50px; */\n  /* bottom: -15px; */\n  /* right: -5px; */\n}\n\n.key-table-cb-chatbot {\n  color: white;\n  padding-top: 15px;\n  padding-bottom: 5px;\n  font-size: 13px;\n  font-family: Graphik;\n  font-weight: 400;\n  margin-top: 27px;\n  margin-left: 6px;\n  line-height: 40px;\n  margin-bottom: 10px;\n}\n\n.topside-chatbot {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n}\n\n.chat-table-chatbot {\n  width: 20px;\n}\n\n.detected-ct-chatbot {\n  background-image: linear-gradient(to right, rgba(72, 48, 239, 1), rgba(128, 69, 237, 1));\n  height: 140px;\n  width: 200px;\n  margin-left: 15px;\n  border-radius: 8px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.heading-dt-chatbot {\n  color: white;\n  font-size: 14px;\n  height: 30px;\n  font-family: Graphik;\n  font-weight: 500;\n  text-align: center;\n  width: 150px;\n  margin-left: 25px;\n}\n\n.chatbot-img-chatbot {\n  height: 90px;\n  width: 180px;\n  margin-left: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n}\n\n.detected-ct-below-chatbot {\n  background-color: rgba(121, 93, 239, 1);\n  height: 50px;\n  width: 200px;\n  color: white;\n  font-size: 14px;\n  font-family: Graphik;\n  font-weight: 500;\n  margin-top: 14px;\n  text-align: center;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  padding: 5px;\n}\n\n.insights-head-chatbot {\n  color: white;\n  font-size: 15px;\n  font-family: Graphik;\n  font-weight: 420;\n  text-align: left;\n  margin-top: 20px;\n  margin-left: 10px;\n}\n\n.insight-button-chatbot {\n  width: 400px;\n  display: flex;\n  margin-left: 10px;\n  margin-top: 10px;\n  flex-direction: column;\n}\n\n.insight-left-button-chatbot:hover {\n  background-color: rgba(116, 123, 169, 1);\n  transition: 0.7s;\n}\n\n.insight-left-button-l-chatbot:hover {\n  background-color: rgba(116, 123, 169, 1);\n  transition: 0.7s;\n}\n\n.insight-left-button-chatbot {\n  height: 30px;\n  min-width: 170px;\n  max-width: 210px;\n  border-radius: 18px;\n  border-style: solid;\n  border-color: rgba(116, 123, 169, 1);\n  border-width: 1px;\n  color: white;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 400;\n  background-color:\n    rgba(37, 40, 67, 1);\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.insight-left-button-l-chatbot {\n  height: 30px;\n  width: 330px;\n  border-radius: 18px;\n  border-style: solid;\n  border-color: rgba(116, 123, 169, 1);\n  border-width: 1px;\n  color: white;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 400;\n  background-color:\n    rgba(37, 40, 67, 1);\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.send-icon-chatbot {\n  width: 50px;\n  height: 90px;\n  display: flex;\n  flex-direction: column;\n  /* margin-top: 10px; */\n  /* padding-top: 35px; */\n}\n\n\n.mic-chart-chatbot {\n  padding: 2px;\n  width: 25px;\n  height: 25px;\n  border-radius: 3px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  background-color: rgba(37, 40, 67, 1);\n  margin-bottom: 10px;\n}\n\n.send-chart-chatbot {\n  padding: 2px;\n  width: 30px;\n  height: 30px;\n  margin-top: 30px;\n  border-radius: 3px;\n  border: 1px solid #747BA9;\n  background-color: #1A1C35;\n}\n\n.bottom-part-chart-chatbot {\n  margin-top: 10px;\n  display: flex;\n  width: 100%;\n  background-color: rgb(54, 54, 89);\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border: 1px solid #6B5CD1;\n}\n\n.midside-chatbot {\n  margin-top: 20px;\n  border-top: 1px solid rgba(14, 190, 147, 1);\n}\n\n.message-footer-chatbot {\n  display: flex;\n  /* background-color: rgba(116, 123, 169, 1); */\n  border: 1px solid rgba(116, 123, 169, 1);\n  height: 34px;\n  justify-content: space-between;\n  padding: 5px 10px 5px 10px;\n  margin: -10px;\n  border-radius: 0px 0px 10px 10px;\n  margin-top: 10px;\n}\n\n.msg-icon-chatbot {\n  width: 17px;\n  float: right;\n  margin-right: 10px;\n  padding-top: 2px;\n}\n\n.msg-icon-copy-chatbot {\n  width: 12px;\n  float: right;\n  margin-right: 10px;\n  padding-top: 2px;\n}\n\n.msg-icon-share-chatbot {\n  width: 15px;\n  float: right;\n  margin-right: 10px;\n  padding-top: 2px;\n}\n\n.border-score-chatbot {\n  margin-left: 10px;\n  padding-left: 10px;\n  border-left: 1px solid white;\n  height: 20px;\n}\n\n.topside-table-chatbot {\n  width: 187px;\n  height: 180px;\n}\n\n.cal-data-chatbot {\n  color: white;\n  padding: 2px;\n  margin-top: 6px;\n  margin-left: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.cal-one-chatbot {\n  padding-right: 50px;\n  /* justify-content: space-between; */\n}\n\n.cal-row-chatbot {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  font-family: Graphik;\n  padding-top: 10px;\n}\n\n.container-cal-data-chatbot {\n  background-color: #25304C;\n  width: 100px;\n  height: 30px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  text-align: left;\n  padding: 5px;\n  color: white\n}\n\n.processebutton-calculate-chatbot {\n  border-radius: 8px;\n  margin-right: 40px;\n  background-color: rgba(107, 92, 209, 1);\n  color: white;\n  text-align: center;\n  text-decoration: none;\n  font-size: 15px;\n  width: 140px;\n  height: 30px;\n  /* border-style: solid; */\n  border: 0px solid rgba(107, 92, 209, 1);\n  float: right;\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\n\n.add-data-chatbot {\n  overflow-y: scroll;\n  padding-top: 10px;\n  height: 90%;\n}\n\n.table-chatbot {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.table-chatbot th {\n  border: 1px solid rgba(87, 95, 142, 1);\n  padding: 8px;\n  text-align: center;\n  background-color: rgba(60, 64, 105, 1);\n}\n\n.table-chatbot td {\n  border: 1px solid rgba(87, 95, 142, 1);\n  padding: 8px;\n  text-align: left;\n}\n\n/* .icon-chatbot-g {\n  width: \"25px\";\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
